module.exports = __webpack_public_path__ + "static/media/adobe.56d61222.svg";